import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./styles.css";
import UserList from "./UserList";
import UserPermission from "../../components/UserPermission";
import { Typography } from "@mui/material";

const classes = {
  message: {
    padding: 10,
    backgroundColor: "#FFFBE8",
    color: "rgba(0,0,0,0.8)",
    borderRadius: 7,
    width: "100%",
  },
};

export default function CadastroDeUsuario() {
  const history = useNavigate();

  /* Permissão do usuário no sistema */
  let userPermission = UserPermission();

  useEffect(() => {
    if (userPermission !== "admin") {
      toast.error("Seu usuário não possuí privilégios para acessar essa página!");
      history("/search");
    }
  }, [userPermission, history]);

  if (userPermission !== "admin") {
    return null;
  } else {
    return (
      <div style={{ position: "relative" }}>
        <div className="register-container">
          <div
            style={{
              backgroundColor: "#F5F5F5",
              borderRadius: 10,
              padding: 20,
            }}
            id="user-list"
          >
            <Typography
              variant="h5"
              align="center"
              style={{
                margin: 8,
                color: "#103168",
                fontWeight: 600,
                marginBottom: 30,
              }}
            >
              Listagem de usuários
            </Typography>
            <div style={classes.message}>
              Consulte abaixo por uma operação do sistema.
            </div>

            <div>
              <UserList />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
